import { useEffect } from 'react';

import { CopyToClipboardTextInput, type TextInputProps } from '@/components/Form';

import useGeneratePixelURL from './useGeneratePixelURL';

type Props = Omit<TextInputProps, 'className' | 'onValueChange'> & {
  className?: string;
  value?: string;
  vendorId: string;
  onUrlChange?: (pixelUrl: string) => void;
  onValueChange?: (code: string) => void;
};

const PixelURLInput = ({ value, onValueChange, onUrlChange, vendorId, ...props }: Props) => {
  const { code, url } = useGeneratePixelURL(vendorId, value) || {};

  useEffect(() => {
    // Let the parent form know we have a new code we generated. The input component is readOnly
    // so let's manually fire change callbacks when we create a new tagId.
    if (code && onValueChange) {
      onValueChange(code);
    }
    if (url && onUrlChange) {
      onUrlChange(url);
    }
  }, [code, url, onValueChange, onUrlChange]);

  return <CopyToClipboardTextInput {...props} value={url} />;
};

export default PixelURLInput;
